angular.module('app')
	.controller('innerCtrl', function ($scope, $rootScope, $http, $location, $filter, HttpService, $timeout, $window, FactoryObj, FileUploader, $download) {

		$scope.pdfUrl = $configService.getAppConfig().url + '/order/download/service-infos/124203/046/testipotesi%20(26).pdf/?token=' + $configService.getAppConfig().token + '&embedded=true';

		$scope.statoPratica = {
			singleStatoPratica: 'Da Lavorare',
			arrStatoPratica: ['Da Lavorare', 'In Lavorazione Alba', 'Scaduta', 'Completata', 'Da Correggere']
		}

		$scope.uploadData = null;
		$scope.idOrder = null;
		$scope.listafile = [];
		$scope.load = false;
		$scope.files;
		$scope.mergedFileName;
		$scope.folderPath;
		$scope.filesNames = [];
		$scope.uploadCompleted = false;
		$scope.expanded = true;
		$scope.searching = false;
		$scope.tempAnteTextValue = null;
		$scope.orderItemList = [];
		$scope.binDisabledMap = {};
		$scope.uploading = false;
		$scope.textareaRifiuto = $scope.selectedOrder.metadataAppOrderPojo.abortMessage;

		$scope.pdfTemplateUrl = context + 'common-ng-include/pdf-template.html';

		$scope.contract = {
			pin: null,
			otp: null
		};

		$scope.checkList = [
			{
				text: 'Ho preso visione delle Norme Generali del Contratto',
				checked: false
			},
			{
				text: 'Ho preso visione delle Clausole specifiche riportate nei Paragrafi 4,5 e 6 del presente Contratto',
				checked: false
			},
			{
				text: 'Ho preso visione delle condizioni economiche del Contratto',
				checked: false
			}
		];

		$scope.allChecked = false;

		$scope.check = function (index) {
			console.log('checkkk');
			$scope.checkList[index].checked = !$scope.checkList[index].checked;

			$scope.allChecked = $scope.checkList.every(function (curr) {
				return curr.checked;
			});
		}

		$scope.sign = function () {
			$rootScope.showSuccessMsg = true;
			$rootScope.changePracticeStatus = true;
			$rootScope.goTo('/');
		}


		$scope.uploadDataFunc = function (requiredDoc, index) {
			$scope.uploadData = requiredDoc;
			$scope.currentCodeTypeNameIndex = index;
		}

		if ($scope.textareaRifiuto != null && $scope.textareaRifiuto != '') {
			$scope.configuratorMD.abortDocSaved = true;
		}

		$scope.uploader = new FileUploader({
			url: '',
			headers: {
				'Access-Control-Allow-Origin': '*',
				'Token': 'Bearer ' + ($configService.getAppConfig().token || 'no-token'),
				'App-Name': $rootScope.portalName
			}
		});

		$scope.finalUpload = function (item) {
			$scope.folderPath = '' + new Date().getTime();
			var url = $configService.getAppConfig().url + '/order/upload/service-infos/' + $scope.selectedOrder.idOrder + '/' + item.codiceDocNSIL + '/';
			//$scope.deleteDocument(item);
			for (var int = 0; int < $scope.uploader.queue.length; int++) {
				$scope.uploader.queue[int].url = url;
			}
			$scope.uploading = true;
			$scope.uploader.uploadAll();
		}

		$scope.generateDownloadLink = function (item, directory) {
			var url = '/order/download/service-infos/' + encodeURIComponent($scope.selectedOrder.idOrder) + '/' +
				encodeURIComponent(directory) + '/' + encodeURIComponent(item.nameFile) + '/';

			$download.getGenericDownload(url)
				.then(function (response) {
					console.log(response);
				})
		}

		$scope.uploader.onWhenAddingFileFailed = function (item /*{File|FileLikeObject}*/, filter, options) {
			console.info('onWhenAddingFileFailed', item, filter, options);
		};

		$scope.uploader.onAfterAddingFile = function (fileItem) {
			if (fileItem.file.size > 26214400) {
				$rootScope.$broadcast('addAlert', { text: 'MAXIMUM_FILE_SIZE_EXCEEDED' });
				fileItem.remove();
				return;
			}
			var fileName = fileItem.file.name;
			if (fileName.toLowerCase().indexOf('.pdf') > -1 || fileName.toLowerCase().indexOf('.png') > -1 || fileName.toLowerCase().indexOf('.jpg') > -1 || fileName.toLowerCase().indexOf('.jpeg') > -1) {
				$scope.uploader.queue[0].progress = 0;
			} else {
				fileItem.remove();
				$rootScope.$broadcast('addAlert', { text: 'FORMAT_NOT_SUPPORTED' });
			}
			//console.info('onAfterAddingFile', fileItem);
		};

		$scope.uploader.onAfterAddingAll = function (addedFileItems) {
			console.info('onAfterAddingAll', addedFileItems);
			$scope.finalUpload($scope.uploadData);
		};

		$scope.uploader.onBeforeUploadItem = function (item) {
			item.file.name = window.encodeURIComponent(item.file.name);
			item.headers['Token'] = 'Bearer ' + $configService.getAppConfig().token;
		};

		$scope.uploader.onProgressItem = function (fileItem, progress) {
			$scope.uploadCompleted = false;
			//console.info('onProgressItem', fileItem, progress);
		};

		$scope.uploader.onProgressAll = function (progress) {
			//console.info('onProgressAll', progress);
		};

		$scope.uploader.onSuccessItem = function (fileItem, response, status, headers) {
			//console.info('onSuccessItem', fileItem, response, status, headers);
			$scope.uploading = false;
		};

		$scope.uploader.onErrorItem = function (fileItem, response, status, headers) {
			console.info('onErrorItem', fileItem, response, status, headers);
			$rootScope.$broadcast('addAlert', { text: 'ERROR_UPLOADING_FILE' });
			fileItem.remove();
		};

		$scope.uploader.onCancelItem = function (fileItem, response, status, headers) {
			//console.info('onCancelItem', fileItem, response, status, headers);
		};

		$scope.uploader.onCompleteItem = function (fileItem, response, status, headers) {
			console.info('onCompleteItem', fileItem, response, status, headers);
			if (response.success == true) {
				if ($scope.searchIndexOneType == 'inner-view-abort') {
					angular.forEach($scope.selectedOrder.metadataAppOrderPojo.uploadedfileAbort, function (item) {
						if (item.codiceDocNSIL == response.folderPath) {
							item.files.push({ "fileStatus": 1, "selected": false, "nameFile": response.fileName });
						}
					})
				} else {
					angular.forEach($scope.selectedOrder.metadataAppOrderPojo.uploadedfile, function (item) {
						if (item.codiceDocNSIL == response.folderPath) {
							item.files.push({ "fileStatus": 1, "selected": false, "nameFile": response.fileName });
						}
					})
				}
				$scope.updateMetadata();
			}
			$scope.uploader.queue = [];

			if ($scope.searchIndexOneType == 'inner-view-abort') {
				$scope.configuratorMD.abortDocUploaded = true;
				$rootScope.canContinueAbortCheck($scope.configuratorMD, $scope.selectedOrder);
			} else {
				$rootScope.canContinueCheck($scope.selectedOrder);
			}
			//$configService.getAppConfig().token = headers['x-refresh-token'];
		};

		$scope.uploader.onCompleteAll = function () {
			console.info('onCompleteAll');
			$scope.uploadCompleted = true;
		};

		//------------------------------------------

		$scope.deleteDocument = function (item) {
			var deleteInput = {};

			if ($scope.selectedOrder.practiceStatus == $rootScope.propMap['POS_DA_CORR']) {
				deleteInput = {
					idOrder: $scope.selectedOrder.idOrder,
					codTypeName: item.codiceDocNSIL
				};
				var i = 0;
				var tempItem = item.files;
				item.files = [];
				angular.forEach(tempItem, function (file) {
					if (file.fileStatus == propMap['DOC_ERRATO'] || file.selected == true) {
						console.log('FILE: ', file);
						deleteInput.fileName = file.nameFile;
						HttpService.send('/order/deleteFile', deleteInput, false).then(function (response) {
						});
					}
					else {
						item.files.push(file);
					}
				});
			}
			else {
				deleteInput = {
					idOrder: $scope.selectedOrder.idOrder,
					codTypeName: item.codiceDocNSIL
				};
				var tempItem = item.files;
				item.files = [];

				if ($scope.searchIndexOneType == 'inner-view-abort') {
					deleteInput.fileName = tempItem[0].nameFile;
					HttpService.send('/order/deleteFile', deleteInput, false).then(function (response) {
					});
				}
				else if ($scope.searchIndexOneType == 'inner-view-sign-contract') {
					var i = 0;
					item.files = [];
					angular.forEach(tempItem, function (file) {
						if (file.selected == true) {
							deleteInput.fileName = file.nameFile;
							HttpService.send('/order/deleteFile', deleteInput, false).then(function (response) {
							});
						}
						else {
							item.files.push(file);
						}
					});
				}
			}

			/** Updating the metadata after deleting a file **/
			$scope.updateMetadata();
			if ($scope.searchIndexOneType == 'inner-view-abort') {
				$scope.configuratorMD.abortDocUploaded = false;
				$rootScope.canContinueAbortCheck($scope.configuratorMD, $scope.selectedOrder);
			} else {
				$rootScope.canContinueCheck($scope.selectedOrder);
			}
		}



		$scope.updateMetadata = function () {
			HttpService.send('/order/updateMetadata', { appOrder: $scope.selectedOrder }).then(function (response) {
				console.log('tornato! ', response);
			});
		}
		//------------------------------------------

		$scope.toJsonAdvancedCheckbox = function (p, c) {
			var output = JSON.stringify({ p: p, c: c });
			return output;
		}

		$scope.isBinDisabled = function (docArray) {
			if (!docArray) { return false; }

			for (var i = 0; i < docArray.length; i++) {
				if (docArray[i].selected == true) {
					return false;
				}
			}
			return true;
		}

		$scope.isUploadDisabled = function (index) {
			if ($rootScope.isPracticeStatus($scope.selectedOrder, [$rootScope.propMap['POS_DA_LAV'], $rootScope.propMap['POS_DA_CORR']])) {
				var currentRow = $scope.selectedOrder.metadataAppOrderPojo.uploadedfile[index];
				if ($rootScope.isPracticeStatus($scope.selectedOrder, [$rootScope.propMap['POS_DA_CORR']])) {
					if (currentRow.maxUploadableFiles == currentRow.files.length && !$scope.rowIsNotValid(index)) {
						return true;
					}
				}
				else if (currentRow.maxUploadableFiles == currentRow.files.length) {
					return true;
				} else { return false; }
			}
		}

		$scope.noFilesUploaded = function () {
			var rows = $scope.selectedOrder.metadataAppOrderPojo.uploadedfile;
			var isEmpty = 1;
			for (var i = 0; i < rows.length; i++) {
				rows[i].files.length === 0 ? isEmpty += 0 : isEmpty -= 1;
			}
			if (isEmpty === 1) {
				return true;
			} else {
				return false;
			}
		}

		$scope.isTextareaEmpty = function (item) {
			console.log(item);
			$scope.emptyTextArea = false;
		}
		/*
			 $scope.isPracticeStatus = function(statusCode){
				if(arguments.length==1){
				   if(statusCode == $scope.selectedOrder.practiceStatus){
					 return true;
				   }
				 } else {
					// if more than 1 argument is provided, assume it's an OR operator
					for(var i = 0; i<arguments.length;i++){
					  if(arguments[i]==$scope.selectedOrder.practiceStatus){
						return true;
					  }
					}
				 }
				return false;
				 }*/

		$scope.advCheckboxSelection = function (jsonInput) {
			//check item
			var parsed = JSON.parse(jsonInput);
			var parent = parsed.p;
			var child = parsed.c;
			var row;
			if ($scope.searchIndexOneType == 'inner-view-abort') {
				row = $scope.selectedOrder.metadataAppOrderPojo.uploadedfileAbort[parent];
			} else {
				row = $scope.selectedOrder.metadataAppOrderPojo.uploadedfile[parent];
			}
			row.files[child].selected = !row.files[child].selected;
		}

		$scope.saveAbortMsg = function (msg) {
			$scope.selectedOrder.metadataAppOrderPojo.abortMessage = msg;
			$scope.updateMetadata();
		}

		$scope.resetAbort = function () {
			$scope.configuratorMD.abortDocSaved = false;
			$scope.configuratorMD.abortDocUploaded = false;
			if ($scope.selectedOrder.metadataAppOrderPojo.uploadedfileAbort.files) {
				if ($scope.selectedOrder.metadataAppOrderPojo.uploadedfileAbort[0].files.length > 0) {
					$scope.deleteDocument($scope.selectedOrder.metadataAppOrderPojo.uploadedfileAbort[0]);
				}
			}
			$scope.selectedOrder.metadataAppOrderPojo.downloadedAbortFile = false;
			$scope.selectedOrder.metadataAppOrderPojo.abortMessage = null;
			$scope.textareaRifiuto = '';
			$scope.updateMetadata();
			$rootScope.canContinueAbortCheck($scope.configuratorMD, $scope.selectedOrder);
		}

		$scope.downloadedDoc = function (file) {
			if (file == 'abort') {
				$scope.selectedOrder.metadataAppOrderPojo.downloadedAbortFile = true;
			}
			$scope.updateMetadata();
		}



		/* Row checks for practice status 'da correggere' */

		$scope.rowIsValid = function (index) {
			function checkFiles(currentFile) {
				return currentFile.fileStatus && currentFile.fileStatus == $rootScope.propMap['DOC_CORRETTO'];
			}

			if ($scope.selectedOrder.metadataAppOrderPojo.uploadedfile[index].files.length) {
				return $scope.selectedOrder.metadataAppOrderPojo.uploadedfile[index].files.every(checkFiles);
			} else {
				return false;
			}
		}

		$scope.rowNeedsCheck = function (index) {
			/*function checkFiles(currentFile){
					return currentFile.fileStatus != propMap['DOC_DA_CORREGGERE'];
			}
			return $scope.selectedOrder.metadataAppOrderPojo.uploadedfile[index].files.every(checkFiles);
			*/

			//check if at least 1 file is new
			function checkFiles(currentFile) {
				return currentFile.fileStatus == propMap['DOC_NUOVO'];
			}
			return $scope.selectedOrder.metadataAppOrderPojo.uploadedfile[index].files.some(checkFiles);
		}

		$scope.rowIsNotValid = function (index) {
			function checkFiles(currentFile) {
				return currentFile.fileStatus == propMap['DOC_ERRATO'];
			}

			return $scope.selectedOrder.metadataAppOrderPojo.uploadedfile[index].files.some(checkFiles);
		}

	});
